// pages/SuperAdminDashboard.jsx
import React, { Component } from "react";
import { withRouterParams } from "../utils/withRouterParams";
import Submenu from "../components/Submenu";
import DashboardWrapper from "../components/DashboardWrapper";
import BackgroundLayer from "../components/BackgroundLayer";
import SuperAdminOrganizations from "../components/superadmin/SuperAdminOrganizations";
import SuperAdminAdmins from "../components/superadmin/SuperAdminAdmins";
import SuperAdminSettings from "../components/superadmin/SuperAdminSettings";

class SuperAdminDashboard extends Component {
    static pageType = "superadmin";

    componentDidMount() {
        this.renderActiveView();
    }

    renderActiveView = () => {
        const tab = new URLSearchParams(this.props.location.search).get("tab");
        console.log(tab)
        if (!tab) {
           return  this.renderDefault()
        } else {
            switch (tab) {
                case "organizatii":
                    return <SuperAdminOrganizations />;
                case "admins":
                    return <SuperAdminAdmins />;
                case "settings":
                    return <SuperAdminSettings />;
                default:
                    return <div>Selectează o secțiune din submenu.</div>;
            }
        }

    };

    renderDefault = () => {
        return <div>SUPERADMIN DASHBOARD</div>
    }

    render() {
        return (
            <div id="superadminDashboard" className="layout-center">
                <BackgroundLayer
                    imgPath="./images/"
                    isBgVisible={this.props.isBgVisible}
                />

                <Submenu role="superadmin" />

                <DashboardWrapper>{this.renderActiveView()}</DashboardWrapper>
            </div>
        );
    }
}

export default withRouterParams(SuperAdminDashboard);
